import { createSlice } from "@reduxjs/toolkit";

const ticketCategorySlice = createSlice({
  name: "ticketCategory",
  initialState: {
    ticketCategory: null,
  },
  reducers: {
    setTicketCategory: (state, action) => {
      state.ticketCategory = action.payload;
    },
    clearTicketCategory: (state) => {
      state.ticketCategory = null;
    },
  },
});

export const { setTicketCategory, clearTicketCategory } =
  ticketCategorySlice.actions;
export default ticketCategorySlice.reducer;
